import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-master',
  templateUrl: './report-master.component.html',
  styleUrls: ['./report-master.component.scss']
})
export class ReportMasterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  openreportModal(){
    document.getElementById("reportModal").style.display='block';
  }
  closereportModal(){
    document.getElementById("reportModal").style.display='none';
  }
}
